import React from 'react'
import Link from 'gatsby-link'

import PageHeader from '../__components/PageHeader'
import PAGE_HEADER from '../img/pageheaders/services_bd.jpg'

import ShareButtons from '../__components/ShareButtons'

const pageMeta = {
  title: "Brilliant Distinctions",
  desc: '"BRILLIANT SAVINGS. BRILLIANT REWARDS."'
};
const AboutPage = ({ transition }) => (
  <div style={transition && transition.style} className="page">
    <PageHeader bgPhoto={PAGE_HEADER} contain={true} styles={{ backgroundColor: "#e9e9e9" }} />

    {typeof window !== 'undefined' &&
      <ShareButtons location={location.href} desc={pageMeta.desc} />
    }

    <div className="container">
      <div className="title-bar">
        <h1>{pageMeta.title}</h1>
        <p>{pageMeta.desc}</p>
      </div>

      <p>
      Brilliant Distinctions is a loyalty program whereby as a member, you’ll earn points on select Allergan products that will help you save big on future purchases. You will also gain access to valuable member – only content, including special offers and beauty tips. Sign up on the day of your first treatment to get started! 
      </p>
    </div>
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/services-brilliant-distinctions.js